import { ReactNode } from 'react'
import { clsx } from 'clsx'

interface CardProps {
  children: ReactNode
  className?: string
  id?: string
  onClick?: () => void
  hover?: boolean
}

export const Card = ({ children, className, id, onClick, hover = false }: CardProps) => {
  return (
    <div
      id={id}
      className={clsx(
        'card',
        hover && 'hover:shadow-lg cursor-pointer',
        onClick && 'cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
